module.exports = __webpack_public_path__ + "static/media/g-3.f3461029.jpg";